import { RectangleStackIcon } from "@heroicons/react/24/solid";
import React from "react";

const CarrierTitleHeader = () => {
  return (
    <>
      <div className="flex gap-2 items-center">
        <RectangleStackIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
        <div className="flex flex-col leading tight">
          <h3 className="text-xs font-medium text-gray-500">Carrier Module</h3>
          <h1 className="mr-auto font-bold text-primary text-md uppercase">
            ALL Carriers
          </h1>
        </div>
      </div>
    </>
  );
};

export default CarrierTitleHeader;
